import { create } from 'zustand'

type TModalButtonColor = 'primary' | 'secondary' | 'primary-alt' | 'negative'

export type TModalButton = {
  label: string
  onClick?: (closeDialog: () => void) => void
  color?: TModalButtonColor
}

export interface IAppDialogOptions {
  title: string
  subtitle?: string
  text?: string[]
  buttonDirection: 'column' | 'row'
  buttons: TModalButton[]
  dialogSize?: 'Regular' | 'Large'
  imageSrc?: string
  isDismissable?: boolean
  textAlign?: 'text-left' | 'text-center' | 'text-right'
  titleAlign?: 'text-left' | 'text-center' | 'text-right'
}

interface ILegalAgreementDialogOptions {
  title: string
  src: string
}

interface INotificationModalContent {
  text: React.ReactNode
  icon?: string
  autoHideDuration?: number
}

interface UIState {
  showAppDialog: boolean
  showEmailExistsModal: boolean
  showLegalAgreementDialog: boolean
  showLottieLoader: boolean
  showNotificationModal: boolean
  showInstacashEligibleDialog: boolean
  showRoarMoneyBenefitDialog: boolean
  instacashEligibleDialogOnClose?: () => void
  appDialogOptions: IAppDialogOptions | undefined
  legalAgreementDialogOptions: ILegalAgreementDialogOptions | undefined
  notificationModalContent: INotificationModalContent | undefined
  setShowAppDialog: (value: boolean, options?: IAppDialogOptions) => void
  setShowEmailExistsModal: (value: boolean) => void
  setShowLegalAgreementDialog: (
    value: boolean,
    options: ILegalAgreementDialogOptions | undefined
  ) => void
  setShowLottieLoader: (value: boolean) => void
  setShowNotificationModal: (
    value: boolean,
    content?: INotificationModalContent
  ) => void
  setShowInstacashEligibleDialog: (value: boolean, onClose?: () => void) => void
  setShowRoarMoneyBenefitDialog: (value: boolean) => void
}

const useUIStore = create<UIState>()((set) => ({
  showAppDialog: false,
  showEmailExistsModal: false,
  showLegalAgreementDialog: false,
  showLottieLoader: false,
  showNotificationModal: false,
  showInstacashEligibleDialog: false,
  showRoarMoneyBenefitDialog: false,
  appDialogOptions: undefined,
  legalAgreementDialogOptions: undefined,
  notificationModalContent: undefined,
  setShowAppDialog: (value, options) => {
    if (options) {
      set({ appDialogOptions: options, showAppDialog: value })
    } else {
      set({ appDialogOptions: undefined, showAppDialog: value })
    }
  },
  setShowEmailExistsModal: (value) => set({ showEmailExistsModal: value }),
  setShowLegalAgreementDialog: (value, options) => {
    if (options) {
      set({
        legalAgreementDialogOptions: options,
        showLegalAgreementDialog: value,
      })
    } else {
      set({
        legalAgreementDialogOptions: undefined,
        showLegalAgreementDialog: value,
      })
    }
  },
  setShowLottieLoader: (value) => set({ showLottieLoader: value }),
  setShowNotificationModal: (value, content) => {
    set((state) => ({
      showNotificationModal: value,
      notificationModalContent: content || state.notificationModalContent,
    }))
  },
  setShowInstacashEligibleDialog: (value, onClose) => {
    set({
      showInstacashEligibleDialog: value,
      instacashEligibleDialogOnClose: onClose,
    })
  },
  setShowRoarMoneyBenefitDialog: (value) => {
    set({ showRoarMoneyBenefitDialog: value })
  },
}))

export { useUIStore }
